export default __webpack_public_path__ + "static/media/gallery (14).8b408879.png";